import React from 'react';
import { useIntl } from 'react-intl';
import { useAppSelector } from '../../../hooks/redux-hooks';
import { RootState } from '../../../store';

interface IProductGuidePDFProps {
    linkKey: string;
    titleDefault: string;
    descriptionDefault: string;
    linkDefault: string;
    downloadTextDefault: string;
}

export default function ProductGuidePDF({
    linkKey,
    titleDefault,
    descriptionDefault,
    linkDefault,
    downloadTextDefault,
}: IProductGuidePDFProps) {
    const intl = useIntl();
    const session = useAppSelector((state: RootState) =>
        state.session ? state.session.data! : null
    );

    return (
        <div
            style={{
                margin: '27px 0 20px',
                border: '1px solid lightgray',
                padding: '20px',
                backgroundColor: '#f8f8f8',
            }}
        >
            <h3>
                <strong>
                    {intl
                        .formatMessage(
                            {
                                id: `Title_${linkKey}`,
                                defaultMessage: titleDefault,
                            },
                            {
                                0: session!.selectedBrand,
                            }
                        )
                        .replace('MIRACLE EAR ', '')}
                </strong>
            </h3>
            <p>
                {intl
                    .formatMessage(
                        {
                            id: `Description_${linkKey}`,
                            defaultMessage: descriptionDefault,
                        },
                        {
                            0: session!.selectedBrand,
                        }
                    )
                    .replace('MIRACLE EAR ', '')}
            </p>
            <a
                href={intl.formatMessage({
                    id: `Download_link_${linkKey}_${session!.selectedBrand
                        .replace(' ', '_')
                        .toLowerCase()}`, // e.g. MIRACLE EAR => miracle_ear
                    defaultMessage: linkDefault,
                })}
                className="item-download"
                title="Download the guide"
                target="_blank"
            >
                {intl
                    .formatMessage(
                        {
                            id: `Download_text_${linkKey}}`,
                            defaultMessage: downloadTextDefault,
                        },
                        {
                            0: session!.selectedBrand,
                        }
                    )
                    .replace('MIRACLE EAR ', '')}
            </a>
        </div>
    );
}
